import { useState } from 'react';

// This link is intentionally unrelated to referral attribution.
export function publicShareUrl() {
  const configured = process.env.REACT_APP_PUBLIC_APP_URL;
  try {
    const candidate = new URL(configured || '/', window.location.origin);
    if (!['https:', 'http:'].includes(candidate.protocol)) return null;
    candidate.search = '';
    candidate.hash = '';
    return candidate.href;
  } catch {
    return null;
  }
}

export default function AppShare() {
  const [open, setOpen] = useState(false);
  const [feedback, setFeedback] = useState('');
  const url = publicShareUrl();
  const subject = 'Découvre ConcoursBF';
  const message = 'Prépare les concours du Burkina Faso avec ConcoursBF : ' + (url || '');
  const encoded = encodeURIComponent(message);
  const isLocal = !!url && /^https?:\/\/(localhost|127\.0\.0\.1)(:|\/)/i.test(url);

  async function share() {
    setFeedback('');
    if (navigator.share && url && !isLocal) {
      try {
        await navigator.share({ title: subject, text: 'Découvre ConcoursBF', url });
        setOpen(false);
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }
    setOpen((value) => !value);
  }

  async function copyLink() {
    if (!url) return setFeedback('Lien de partage indisponible.');
    try {
      await navigator.clipboard.writeText(url);
      setFeedback('Lien copié.');
    } catch {
      setFeedback('Sélectionne le lien ci-dessous pour le copier.');
    }
  }

  return (
    <div className="relative">
      <button type="button" onClick={share} aria-label="Partager ConcoursBF"
        aria-expanded={open} className="px-2 py-1 rounded hover:bg-white/10 text-xs">
        <span className="cb-share-symbol" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"
            focusable="false">
            <circle cx="18" cy="5" r="2.5" />
            <circle cx="6" cy="12" r="2.5" />
            <circle cx="18" cy="19" r="2.5" />
            <path d="m8.2 10.8 7.6-4.4M8.2 13.2l7.6 4.4" />
          </svg>
        </span>
        <span className="cb-share-label">Partager</span>
      </button>
      {open && (
        <div role="group" aria-label="Options de partage"
          className="absolute right-0 top-full mt-2 z-50 w-72 max-w-[90vw] surface-card border border-color rounded-xl p-3 shadow-xl text-primary"
          onClick={(event) => event.stopPropagation()}>
          <strong className="block mb-2 text-sm">Partager l’application</strong>
          {isLocal && <p role="note" className="text-xs text-amber-700 mb-2">
            L’adresse locale ne fonctionne pas sur le téléphone de tes proches. Configure REACT_APP_PUBLIC_APP_URL après déploiement.
          </p>}
          <div className="grid grid-cols-2 gap-2 text-sm">
            <a className="p-2 rounded border border-color hover:bg-secondary" href={'https://wa.me/?text=' + encoded}
              target="_blank" rel="noopener noreferrer">WhatsApp</a>
            <a className="p-2 rounded border border-color hover:bg-secondary"
              href={'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url || '')}
              target="_blank" rel="noopener noreferrer">Facebook</a>
            <a className="p-2 rounded border border-color hover:bg-secondary"
              href={'https://mail.google.com/mail/?view=cm&fs=1&su=' + encodeURIComponent(subject) + '&body=' + encoded}
              target="_blank" rel="noopener noreferrer">Gmail</a>
            <a className="p-2 rounded border border-color hover:bg-secondary"
              href={'https://outlook.live.com/mail/0/deeplink/compose?subject=' + encodeURIComponent(subject) + '&body=' + encoded}
              target="_blank" rel="noopener noreferrer">Outlook</a>
            <a className="p-2 rounded border border-color hover:bg-secondary col-span-2"
              href={'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encoded}>Autre application e-mail</a>
          </div>
          <div className="mt-3 flex gap-2">
            <input aria-label="Lien public de l’application" readOnly value={url || ''}
              onFocus={(event) => event.target.select()}
              className="min-w-0 flex-1 text-xs p-2 rounded border border-color bg-secondary text-primary" />
            <button type="button" onClick={copyLink}
              className="px-3 rounded bg-blue-600 text-white text-xs">Copier</button>
          </div>
          {feedback && <p role="status" className="text-xs mt-2">{feedback}</p>}
          <button type="button" onClick={() => setOpen(false)}
            className="mt-2 text-xs underline">Fermer</button>
        </div>
      )}
    </div>
  );
}
